import { API_MODULE_HORIZONTAL_SIGNING, useHorizontalSigns } from "@l2r-front/l2r-app-city"
import { Campaign } from "@l2r-front/l2r-proptypes"

export function useCampaignItemsCount(campaign: Campaign): number | undefined {

    const { data: horizontalSigns } = useHorizontalSigns(
        {
            campaign: campaign?.uuid,
        },
        {
            enabled: !!campaign && campaign?.campaign_type === API_MODULE_HORIZONTAL_SIGNING,
            filterBySubnetworks: false
        }
    )

    const moduleData = horizontalSigns

    return moduleData?.length
}
